export default __webpack_public_path__ + "static/media/dash-diversity.e1c83ba5.svg";